module.exports = __webpack_public_path__ + "static/media/20ECE23.59321b09.jpg";